import { WebStorageStateStore } from 'oidc-client-ts';

import { PropsWithChildren } from 'react';
import { AuthProvider as ReactAuthContext } from 'react-oidc-context';

import { AppAuthConfig, AppAuthMetadata } from '../config';

export function AuthProvider({ children }: PropsWithChildren) {
  return (
    <ReactAuthContext
      userStore={new WebStorageStateStore({ store: window.localStorage })}
      redirect_uri={AppAuthConfig.redirect_uri}
      client_id={AppAuthConfig.client_id}
      authority={AppAuthConfig.authority}
      scope={AppAuthConfig.scope}
      metadata={AppAuthMetadata}
      loadUserInfo
      automaticSilentRenew={true}
    >
      {children}
    </ReactAuthContext>
  );
}
